import {Component, Input, OnInit} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {PtserialBeansModel} from '../../models/ptserial-beans.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {LokijsService} from '../../services/database/lokijs.service';

@Component({
    selector: 'app-select-product-serial',
    templateUrl: './select-product-serial.page.html',
    styleUrls: ['./select-product-serial.page.scss'],
})
export class SelectProductSerialPage implements OnInit {

    @Input() serials: PtserialBeansModel[];
    @Input() product: DetaillineDTOModel;
    ptSerialsDisplay = [];
    queryText = '';
    count = 0;
    loading: any;

    constructor(public modalController: ModalController,
                private loadingController: LoadingController,
                private loki: LokijsService) {
    }

    ngOnInit() {
        this.loadingInit();
    }

    async init() {
        if (this.product.ptSerialBeans) {
            this.checkSerials();
        } else {
            this.populateDisplayList();
        }
    }


    async loadingInit() {
        await this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading',
            spinner: 'bubbles'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        this.init().then(() => {
            this.loading.dismiss();
        }).catch(() => {
            this.loading.dismiss();
        });
    }

    populateDisplayList() {
        for (const serial of this.serials) {
            this.ptSerialsDisplay.push({serial: serial, isChecked: false});
        }
    }

    checkSerials() {
        this.populateDisplayList();
        for (const productSerial of this.product.ptSerialBeans) {
            this.ptSerialsDisplay.push({serial: productSerial, isChecked: true});
        }
        this.countChecked();
        this.ptSerialsDisplay.sort((a, b) => (a.isChecked < b.isChecked) ? 1 : -1);
    }

    countChecked() {
        this.count = 0;
        for (const item of this.ptSerialsDisplay) {
            if (item.isChecked) {
                this.count++;
            }
        }
    }

    async checkOutSerials() {
        if (this.product.qty !== this.count) {
            alert('Please select serial numbers for ' + this.product.qty + ' products');
        } else {
            const tempSerials = [];
            for (const item of this.ptSerialsDisplay) {
                if (item.isChecked) {
                    tempSerials.push(item.serial);
                }
            }
            await this.updateSerial();
            this.modalController.dismiss(tempSerials);
        }
    }

    async updateSerial() {
        const tempSerials = new Array<PtserialBeansModel>();
        for (const item of this.ptSerialsDisplay) {
            if (item.isChecked) {
                item.serial.stat = 1;
            } else {
                item.serial.stat = 0;
            }
        }
        this.loki.upsert('ptserial', 'id', tempSerials);
    }
}
